<div class="login-container">
  <h2 class="login-container__title">Reset Password</h2>
  <hr class="login-container__divider" />
  <div class="login-container__body">
    <ng-container *ngIf="emailSent">
      <p>Please check your email.</p>
      <p>A link with instructions to change your password has been sent to your account email.</p>
    </ng-container>
    <ng-container *ngIf="!emailSent">
      <ng-container *ngIf="!finishReset">
        <div class="login-container__input">
          <basic-text-input
            #resetEmail
            [propertyName]="'email'"
            [placeholder]="'Email'"
            (valueChanged)="validateEmail()"
          ></basic-text-input>
        </div>
        <button
          class="button button--yellow button--primary login-container__button"
          role="button"
          (click)="resetPassword()"
          [ngClass]="{ 'button--disabled': resetButtonDisabled }"
        >
          Reset Password
        </button>
      </ng-container>
      <ng-container *ngIf="finishReset">
        <div class="login-container__input">
          <basic-text-input
            #resetPassword
            [propertyName]="'newPassword'"
            [placeholder]="'Password'"
            [inputType]="'password'"
            (valueChanged)="validateFinishReset()"
          ></basic-text-input>
        </div>
        <div class="login-container__input">
          <basic-text-input
            #resetConfirmPassword
            [propertyName]="'confirmPassword'"
            [placeholder]="'Confirm Password'"
            [inputType]="'password'"
            (valueChanged)="validateFinishReset()"
          ></basic-text-input>
        </div>
        <div *ngIf="errorMessage" class="login-container__error">{{ errorMessage }}</div>
        <button
          class="button button--yellow button--primary login-container__button"
          role="button"
          (click)="finishResetPassword()"
          [ngClass]="{ 'button--disabled': finishResetButtonDisabled }"
        >
          Reset
        </button>
      </ng-container>
    </ng-container>
  </div>
</div>
